import {
  Box,
  Text,
  Textarea as ChakraTextArea,
  TextareaProps as ChakraTextAreaProps,
} from "@chakra-ui/react";
import React from "react";
import { FieldError } from "react-hook-form";
import { Label } from "../Label";

const enterKeys = ["NumpadEnter", "Enter"];
interface TextAreaProps extends ChakraTextAreaProps {
  label?: string;
  error?: FieldError;
  disabled?: boolean;
  onEnterKeyPress?: () => void;
}

export const TextArea = React.forwardRef<HTMLInputElement, TextAreaProps>(
  ({ label, error, disabled, onEnterKeyPress, ...rest }, ref) => {
    return (
      <Box flex={1} w={"100%"}>
        {!!label && <Label>{label}</Label>}
        <ChakraTextArea
          disabled={disabled}
          ref={ref}
          isInvalid={!!error}
          {...rest}
          onKeyUp={key => {
            if (onEnterKeyPress && enterKeys.includes(key.code)) onEnterKeyPress();
          }}
        />
        {!!error && <Text mt={2}>{error.message?.toString()}</Text>}
      </Box>
    );
  }
);
